import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import DOMPurify from 'dompurify';
import _ from 'lodash';

@Pipe({
   name: 'safeHtml',
})
export class SafeHtmlPipe implements PipeTransform {
   constructor(private sanitizer: DomSanitizer) {}

   public transform(value: string): SafeHtml {
      if (_.isNil(value)) {
         value = '';
      }
      const sanitizedContent = DOMPurify.sanitize(value, { FORBID_TAGS: ['style'] });
      return this.sanitizer.bypassSecurityTrustHtml(sanitizedContent);
   }
}
